import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'totalNewPrice',
    standalone: false
})
export class TotalNewPricePipe implements PipeTransform {
    transform(value: any, ...args: any[]): any {
        let totalPriceForCase = 0;
        let totalInspectorPrice = 0;
        let totalNewPrice = 0;
        let totalSavedPrice = 0;
        let totalClaimPrice = 0;

        if (value && value.length) {
            value.forEach(service => {
                if (service && service.IsServiceActive) {
                    totalClaimPrice = totalClaimPrice + service.SubTotalPrice;
                    totalInspectorPrice = totalInspectorPrice + service.NewSubTotalPrice;
                    totalSavedPrice = totalSavedPrice + (service.SubTotalPrice - service.NewSubTotalPrice);
                }
            });
        }

        return {
            totalClaimPrice: totalClaimPrice.toFixed(2),
            totalNewPrice: totalInspectorPrice.toFixed(2),
            totalSavedPrice: totalSavedPrice === 0 ? 0 : totalSavedPrice.toFixed(2)
        };
    }
}
